import React from 'react';
import { TrackSearch } from '../../SiteHeaderTracking';
import { SearchSource } from '../Enum/SearchSource';
import { getUrl } from '../Helpers/Helpers';
import { useAppState } from '../../AppStateContext';

export const CategorySection = () => {
  const { categories, searchTerm } = useAppState();
  const translations = window._THULEDATA._siteHeader.Translations;

  const handleClick = (category: any) => {
    TrackSearch(searchTerm, SearchSource.SuggestedCategory);
    window.location.href = getUrl(category.url);
  };

  if (!searchTerm.length || !categories?.length) return null;

  return (
    <div className="category-section">
      <p className="paragraph--s section-sub-header">{translations?.Categories}</p>
      <ul>
        {categories.map((category, index) => (
          <li key={index} dangerouslySetInnerHTML={{ __html: category.name }} onClick={() => handleClick(category)} />
        ))}
      </ul>
    </div>
  );
};
